<template>
  <div>
    <tool-bar :title="title"></tool-bar>

    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div class="margin_top_20" v-if="showUI">
        <weex-text class="input_label text-align-center"><u>Attach a copy of your PAN card</u></weex-text>
        <div class="margin-top-20">
            <weex-image
                v-if="dummyPanCardImageURL"
                class="horizontal_center"
                :src="dummyPanCardImageURL"
                style="width: 200px;"
            ></weex-image>
        </div>

        <file-attach-button
            class="margin-top-20"
            ref="upload_document"
            file-attach-button-id="upload_document"
            text="Upload Pan"
            size="full"
            :attach-image-des-src="attachImageSrc"
            :disabled="true"
            :disabled-button-style="attachButtonStyle"
            :disable-text-style="attachButtonTextStyle"
            @attachFilesClicked="onAttachFrontPageClicked"
            @filesAttached="onClientIdentifierAttached($event.files[0])"
        ></file-attach-button>

      <div class="input_container" v-if="panUploaded">
        <input
            class="input_with_border_bottom"
            :value="panNumber"
            @input="panNumberEntered($event.target.value)"
            maxlength="10"
            auto-capitalization-type="allCharacters"
        />
      </div>

      <wxc-button
        text="Next"
        class="margin-top-40 margin-bottom-20 horizontal_center"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import ToolBar from "../layout/ToolBar";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import Loading from "../layout/Loading";
import StageCommentItem from "../layout/StageCommentItem";
import { Activities } from "../../utils/ActivityNavigator";
import DataSource from "../../data/DataSource";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import FileAttachButton from "../layout/FileAttachButton";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import AlertService from "../core/alert/AlertService";
import FieldErrorItem from "../layout/FieldErrorItem";
import RefreshItem from "../layout/RefreshItem";

export default {
  name: "PanAddedActivity",
  components: {
    RefreshItem,
    ActivityRedirectItem,
    ToolBar,
    ErrorAlertItem,
    Loading,
    StageCommentItem,
    FileAttachButton,
    WxcButton,
    FieldErrorItem
  },

  data: () => ({
    title: "Pan Card",
    loading: false,
    showRefreshItem: false,
    showUI: true,
    errorAlertEvent: false,
    networkError: {},
    uploadPanText: "Upload Pan Card",
    panUploaded: false,
    panOCRData: null,
    panNumber: ""
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    onClientIdentifierAttached(file) {
      this.loading = true;
      DataSource.getPanOcrData(file)
      .then(ocrRes => {
        this.loading = false;
        if (!ocrRes.errorOccurred) {
          this.panOCRData = ocrRes.data;
          this.panNumber = this.panOCRData.pan_number;
          this.panUploaded = true;
        }else{
            this.showError(ocrRes.data);
        }
      })
    },

    onSubmit() {
      this.invalidFields = [];
      if (this.checkForValidation()) {
          //Upload PAN and Fetch next stage
          this.completeCurrentTaskAndGetNextTask();
      }
    },

    getErrorMsg(fieldKey) {
      return ALL_FIELDS_DATA[fieldKey]["errorMsg"];
    },

    checkForValidation() {
        //TODO add validation here
        return true;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    fetchInitialData() {
      //TODO fetch PAN number here
    },

    onAttachFrontPageClicked() {
      if (this.checkForValidation()) {
        this.$refs.upload_document.attachFile();
      }
    },

    panNumberEntered(panNumber) {
      this.panNumber = panNumber.toUpperCase();
    },

  },

  created() {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.PAN_ADDED];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    documentAttachImage() {
      return this.panUploaded
        ? ImageResourcesUtil.getImageLink(ImageResourcesUtil.TICK_GREEN)
        : ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },

    dummyPanCardImageURL(){
       return ImageResourcesUtil.getImageLink(ImageResourcesUtil.PAN_TEMPLATE)
    },

    attachImageSrc() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CAMERA_ADD);
    },

    attachButtonStyle() {
      return {
        backgroundColor: "#ffffff",
        "border-width": "1px",
        "border-color": "#B5B5B5",
        "border-style": "solid"
      };
    },

    attachButtonTextStyle() {
      return {color: "#000000", "font-weight": "bold"};
    },
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

